const mutations = {
  LOAD_LIST_EVENT_DISCOUNT(state, list) {
    state.listaEventDiscounts = list;
  },
  PREPARE_TO_EDIT_EVENT_DISCOUNT(state, data) {
    state.eventDiscount = { ...data };
  },
  RESET_EVENT_DISCOUNT(state) {
    state.eventDiscount = {
      id: null,
      descricao: "",
      evento: { id: null },
      tipo: { id: null },
      tipoRegistro: { id: null },
      percentualDesconto: 0,
      valorDesconto: "",
      ativo: true,
    };
  },
};

export default mutations;
